import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  padding: 16px 16px 0 16px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.p<{ active: boolean }>`
  color: ${({ active }) => (active ? "blue" : "inherit")};
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
`;

export const StyledButton = styled.button<{ active: boolean }>`
  border-bottom: ${({ active }) =>
    active ? "3px solid blue" : "3px solid #D0D5DD"};
  color: ${({ active }) => (active ? "blue" : "inherit")};
  text-decoration: none;
  background-color: white;
  width: 270px;
  cursor: pointer;
  padding: 12px 36px 24px 36px;
  &:hover {
    background-color: white;
  }
`;

export const Button = styled(IconButton)``;
